// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"0d46c1b2","82":"e97067e2","237":"7bb79ee3","354":"55cda56d","454":"756b1a7d","487":"7cb166c3","507":"d8154bfb","787":"28cb0dcd","810":"7e094355","836":"6a85f2c7","975":"de808e17"}[chunkId] + ".chunk.js";
};